import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../Utility/Normalize.js';
import { SvgWrapper } from '../Utility/SvgWrapper.js';
import '../Utility/UnstyledList.js';

const StarOutlined = forwardRef(function StarOutlined(props, ref) {
    return (jsx(SvgWrapper, Object.assign({ fill: "none", height: "24", viewBox: "0 0 24 24", width: "24" }, props, { ref: ref, children: jsx("path", { clipRule: "evenodd", d: "M14.2249 9.35632L12 3L9.77508 9.35632L3 9.49342L8.4 13.5589L6.43769 20L12 16.1563L17.5623 20L15.6 13.5589L21 9.49342L14.2249 9.35632ZM16.0161 11.1015L12.9928 11.0404L12 8.20395L11.0072 11.0404L7.9839 11.1015L10.3936 12.9157L9.51791 15.7899L12 14.0747L14.4821 15.7899L13.6064 12.9157L16.0161 11.1015Z", fill: "currentColor", fillRule: "evenodd" }) })));
});

export { StarOutlined as default };
//# sourceMappingURL=StarOutlined.js.map
